import { UploadConfirmationDialog } from '../base/upload-confirmation-dialog';
import { MdlDialogReference } from '@angular-mdl/core';
import { UploadDialogBase, UploadState } from '../base/upload-dialog-base';
import { UploadStorage } from '../../storages/upload-storage';
import { GeneralUnreadReportsStorage } from '../../../../general-documents/general-unread-reports-storage';
import { filter, takeUntil, tap } from 'rxjs/operators';

export abstract class GeneralUploadDialogBase extends UploadDialogBase {

    protected constructor(
        uploadStorage: UploadStorage,
        protected readonly dialog: MdlDialogReference,
        private readonly uploadConfirmationDialog: UploadConfirmationDialog,
        protected unreadStorage: GeneralUnreadReportsStorage
    ) {
        super(uploadStorage, dialog);

        this.uploadState.pipe(
            takeUntil(this.onDialogDestroying),
            filter(us => us === UploadState.SuccessUpload),
            tap(() => this.unreadStorage.refreshUnreads())
        ).subscribe();
    }

    protected async showConfirm(audienceRoles?: string[]): Promise<boolean> {
        this.confirmationDialogOpened = true;

        try {
            await this.uploadConfirmationDialog.openDialog(audienceRoles);
            return true;
        } catch {
            return false;
        } finally {
            this.confirmationDialogOpened = false;
        }
    }
}